import React from 'react';
import { FundraiserList } from '../FundraiserList';
import type { Fundraiser } from '../../../types/leaderboard';
import styles from './FundraiserListWidget.module.css';

interface FundraiserListWidgetProps {
  title: string;
  fundraisers: Fundraiser[];
  selectedType: string;
  enabledTypes: string[];
  onTypeChange: (type: string) => void;
  maxItems?: number;
  viewAllLink?: string;
  viewAllText?: string;
  formatFundraiserType: (type: string) => string;
  emptyStateMessage?: string;
  showRank?: boolean;
  onFundraiserClick?: (fundraiser: Fundraiser) => void;
  isLoading?: boolean;
}

export const FundraiserListWidget: React.FC<FundraiserListWidgetProps> = ({
  title,
  fundraisers,
  selectedType,
  enabledTypes,
  onTypeChange,
  maxItems = 10,
  viewAllLink,
  viewAllText,
  formatFundraiserType,
  emptyStateMessage,
  showRank = true,
  onFundraiserClick,
  isLoading = false,
}) => {
  const handleTypeClick = (type: string) => {
    if (selectedType !== type) {
      onTypeChange(type);
    }
  };

  return (
    <div className={styles.leaderboardWidget}>
      <div className={styles.leaderboardWidgetHeader}>
        <h3>
          {title}
        </h3>
        {enabledTypes.length > 1 && (
          <div className={styles.fundraiserTypeToggle}>
            {enabledTypes.map((type) => (
              <button
                key={type}
                onClick={() => handleTypeClick(type)}
                className={`${styles.typeButton} ${
                  selectedType === type ? styles.typeButtonActive : ''
                }`}
              >
                {formatFundraiserType(type)}
              </button>
            ))}
          </div>
        )}
      </div>
      <FundraiserList
        fundraisers={fundraisers}
        maxItems={maxItems}
        viewAllLink={viewAllLink}
        viewAllText={viewAllText}
        emptyStateMessage={emptyStateMessage}
        showRank={showRank}
        onFundraiserClick={onFundraiserClick}
        isLoading={isLoading}
      />
    </div>
  );
};
